/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
 */
export interface GetCustomerPromotions200ResponseCustomerExternalPromotionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    discountType: string;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    discountAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    minExpense?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    pickupType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    freeDelivery?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerExternalPromotionsInner
     */
    products?: Array<string>;
}

/**
 * Check if a given object implements the GetCustomerPromotions200ResponseCustomerExternalPromotionsInner interface.
 */
export function instanceOfGetCustomerPromotions200ResponseCustomerExternalPromotionsInner(value: object): value is GetCustomerPromotions200ResponseCustomerExternalPromotionsInner {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('discountAmount' in value) || value['discountAmount'] === undefined) return false;
    return true;
}

export function GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerFromJSON(json: any): GetCustomerPromotions200ResponseCustomerExternalPromotionsInner {
    return GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerFromJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerPromotions200ResponseCustomerExternalPromotionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'externalId': json['externalId'],
        'organizationId': json['organizationId'],
        'name': json['name'],
        'description': json['description'],
        'discountType': json['discountType'],
        'discountAmount': json['discountAmount'],
        'minExpense': json['minExpense'] == null ? undefined : json['minExpense'],
        'pickupType': json['pickupType'] == null ? undefined : json['pickupType'],
        'freeDelivery': json['freeDelivery'] == null ? undefined : json['freeDelivery'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'products': json['products'] == null ? undefined : json['products'],
    };
}

export function GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerToJSON(json: any): GetCustomerPromotions200ResponseCustomerExternalPromotionsInner {
    return GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerToJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerToJSONTyped(value?: GetCustomerPromotions200ResponseCustomerExternalPromotionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'organizationId': value['organizationId'],
        'name': value['name'],
        'description': value['description'],
        'discountType': value['discountType'],
        'discountAmount': value['discountAmount'],
        'minExpense': value['minExpense'],
        'pickupType': value['pickupType'],
        'freeDelivery': value['freeDelivery'],
        'categories': value['categories'],
        'products': value['products'],
    };
}

